/**
 * this module is used to overwrite all project dependent client config options handled by frontend-controller/lib/appConfig.js
 */
module.exports = {
	useFecClient: true,
	store: {
		name: 'Cookie-Store'
	},
	debug: {
		injectComponentInstanceID: true,
	}
}